import { useCallback, useEffect } from 'react';

import { postData, patchData } from '../utils/http';
import { trackUser } from '../utils/rudderstack';

import { useFetchData } from './useFetchData';

export function usePatientUser(username: string | null) {
  const { data, isError } = useFetchData<Record<string, string>>(
    username && `/patient/${username}/user`
  );

  const setPassword = useCallback(
    (password: string, confirmationCode: string | null) => {
      return postData(`/patient/${username}/password`, {
        password,
        confirmationCode,
      });
    },
    [username]
  );

  const startPasswordRecovery = useCallback((email: string) => {
    return postData(`/password-recovery`, {
      email,
    });
  }, []);

  const updatePassword = useCallback(
    (password: string, verificationCode: string) => {
      return patchData(`/patient/${username}/password`, {
        password,
        verificationCode,
      });
    },
    [username]
  );

  useEffect(() => {
    if (username && data) {
      trackUser(username, data);
    }
  }, [username, data]);

  return {
    user: data,
    setPassword,
    updatePassword,
    startPasswordRecovery,
    isError,
  };
}
